import instance from '@apis/instance';
import {
    OrderAbleResponse,
    CreateFreeOrderResponse,
    CreateOrderRequest,
    CreateOrderResponse,
    OrderReceiptResponse, RecentOrdersResponse,
} from '@models/order';

class OrderApi {
    static createOrder(request: CreateOrderRequest): Promise<CreateOrderResponse> {
        return instance.post('/v1/order/prepare', request);
    }

    static createFreeOrder(request: CreateOrderRequest): Promise<CreateFreeOrderResponse> {
        return instance.post('/v1/order/non-pg', request);
    }

    static getRecentOrders(): Promise<RecentOrdersResponse> {
        return instance.get('/v0/orders/recent');
    }

    static getReceipt(orderId: string): Promise<OrderReceiptResponse> {
        return instance.get(`/v1/order/${orderId}/receipt`);
    }

    static getOrderAble(orderNo: string): Promise<OrderAbleResponse> {
        return instance.get(`/v0/order/${orderNo}/orderable`);
    }

    static cancelOrder(orderNo: string): Promise<never> {
        return instance.post(`/v1/order/${orderNo}/cancel`);
    }
}

export default OrderApi;
